export default {
    labels: {
        country: 'shareholder.list.location.country',
        showForeign: 'shareholder.list.location.showForeign',
        state: 'shareholder.list.location.state',
        zip: 'shareholder.list.location.zipCode'
    }
};
